import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { UIModule } from 'libraries/ui/ui.module';
import { GenericModule } from 'libraries/module/generic.module';
import { AirModule } from 'libraries/module/air.module';
import { PersonModule } from 'libraries/module/person.module';
import { ListModule } from 'libraries/module/list.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { LocobookRoutingModule } from "./locobook-routing";
import { AuthLocobookService } from "./auth/authLocobook.service";
import { SegmentService } from "./service/segment.service";
import { TravellerModule } from "./service/traveller/traveller.module";
import { CarrierService } from "./service/carrier.service";
import { QuoteService } from "./service/quote.service";
import { PNRService } from "./pnr/pnr.service";
import { DateService } from "libraries/date/date.service";
import { PriceService } from "./service/price.service";
import { SSRModule } from "./ssr/ssr.module";
import { CustomFieldService } from "./customField/customField.service";
import { SearchFlightFormService } from "./searchFlightForm/searchFlightForm.service";
import { LocobookComponent } from './locobook.component';
import { SearchComponent } from "./search.component";
import { AbstractCardComponent } from "./abstractCard/abstractCard.component";
import { AbstractItineraryCardComponent } from "./abstractItineraryCard/abstractItineraryCard.component";
import { LabelModule } from "libraries/service/label/label.module";
import { NotepadModule } from "libraries/component/notepad/notepad.module";
import { BookingRemarksModule } from "libraries/component/booking-information/components/booking-remarks/booking-remarks.module";
import { SectorsComponent } from "libraries/sectors/sectors.component";
import { JourneyModule } from "libraries/component/journey/journey.module";
import { PNRPriceTableComponent } from "libraries/pnrPriceTable/pnrPriceTable.component";
import { PermissionModule } from "libraries/permission/permission.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { PermissionDirective } from "libraries/permission/permission.directive";
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { SearchAirTripModule } from 'libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.module';
import { SectorModule } from 'libraries/sector/sector.module';
import { ClipboardDirectiveModule } from 'libraries/clipboard/clipboardDirective.module';
import { LuggageModule } from 'libraries/luggage/luggage.module';
import { SSRComponent } from './ssr/ssr.component';
import { PipesModule } from 'libraries/pipes/pipes.module';
import { PlainTextModule } from 'libraries/service/plainText/plaintText.module';
import { TravellerCardModule } from 'libraries/component/travellerCard/travellerCard.module';
import { ApiResourceModule } from 'libraries/service/apiResource/apiResource.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { PriceDifferenceModule } from 'libraries/price-difference/price-difference.module';
import { TravellerFormModule } from 'libraries/module/formbuilder/forms/travellerForm/travellerForm.module';
import { EqualsModule } from "../libraries/pipes/equals/equals.module";
import { QuoteListModule } from "./pages/quote-page/quote-list.module";
import { BookingModule } from "./shared/booking/booking.module";
import { SegmentModule } from "libraries/segment/segment.module";
import { DetailsDialogModule } from "./shared/details-dialog/details-dialog.module";
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { AllSegmentDialogModule } from "./shared/all-segment-dialog/all-segment-dialog.module";
import { ConfirmDialogModule } from 'libraries/component/dialogs/confirm-dialog/confirm-dialog.module';
import { SamResourceModule } from "libraries/service/resources/sam/samResource.module";
import { LocationPipeModule } from 'libraries/pipes/location/location.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { AirBookingResourceModule } from 'libraries/service/resources/air-booking/air-booking-resource.module';
import { AirOfferResourceModule } from 'libraries/service/resources/airOffer/airOfferResource.module';
import { AirSilentBookingResourceModule } from 'libraries/service/resources/airSilentBooking/airSilentBookingResource.module';
import { SearchFlightFormModule } from './searchFlightForm/searchFlightForm.module';
import { ModalModule } from "libraries/ui_modal/Modal.module";
import { LowCostCompanyModule } from "app_locobook/service/low-cost-company.module";
import { BookingInformationModule } from 'libraries/component/booking-information/booking-information.module';
import { AirBookingDetailsModule } from './pages/air-booking-details/air-booking-details.module';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';
import { IdentityInfoEditorModule } from "libraries/component/identity-info-editor/identity-info-editor.module";
import { CreateBookingWarningMessageService } from "app_locobook/service/create-booking-warning-message.service";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { BestQuotesModule } from "app_locobook/shared/best-quotes/best-quotes.module";
import { LanguageService } from "libraries/service/language/language.service";
import { AfiMatDialogDefaultOptions } from "libraries/component/dialogs/afi-mat-dialog-default-options";
import { GetTravellersModule } from "app_locobook/shared/get-travellers-pipe/get-travellers.module";
import { QuotedAvailabilityModule } from "./service/quoted-availability.module";
import { AirQuoteResourceModule } from "../libraries/service/resources/airQuote/airQuoteResource.module";
import { PricePipe } from "../libraries/pipes/price/price.pipe";
import { PropalModule } from './service/propal/propal.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BreadcrumbIqbaModule } from './service/breadcrumbIqba/breadcrumbIqba.module';
import { ActionQualityHelperModule } from "libraries/service/action-quality-helper/action-quality-helper.module";
import { FareFamilyBenchmarkModule } from './pages/quote-page/components/fare-family-benchmark/fare-family-benchmark.module';
import { ClickStopModule } from "libraries/directive/clickstop/click-stop.module";
import { CacheQuotedAvailabilityModule } from './service/cache-quoted-availability/cache-quoted-availability.module';
import { OfferService } from './service/offer.service';
import { SilentBookingService } from './service/silent-booking.service';
import { AncillaryServicesPageModule } from "./pages/ancillary-services-page/ancillary-services-page.module";

import {
    AncillaryServicesListModule
} from "libraries/component/ancillary-services-list/ancillary-services-list.module";
import { AirBookingResourceService } from 'libraries/service/resources/air-booking/air-booking-resource.service';
import { ItineraryChangeInformationComponent } from "./pages/search/itinerary-change-information/itinerary-change-information.component";
import {
    BookingTravellerAbstractModule
} from "../libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-abstract/booking-traveller-abstract.module";
import {SegmentListModule} from "./shared/segment-list/segment-list.module";
import {
    AncillaryServicesSummaryModule
} from "libraries/component/ancillary-services-summary/ancillary-services-summary.module";
import { QuoteFilterModule } from "app_locobook/pages/quote-page/components/quote-filter/quote-filter.module";
import { AncillaryServicesDomainModule } from "app_locobook/domain/ancillaryServices/ancillary-services-domain.module";

// tslint:disable no-import-side-effect
import 'styles/angular-material/theming.scss?global';
import 'styles/angular-material/mat-table?global';
import 'styles/angular-material/dialog.scss?global';
import 'styles/angular-material/pseudo-checkbox.scss?global';
import 'styles/angular-material/checkbox.scss?global';
import 'styles/angular-material/form-field.scss?global';
import { ExternalRedirectionService } from "app_locobook/service/external-redirection.service";
import { ExternalApplicationService } from "app_locobook/service/external-application/external-application.service";
import { SentryModule } from "../libraries/service/sentry/sentry.module";
import { AirSearchModule } from "./air-search/air-search.module";

@NgModule({
    imports: [
        AirBookingDetailsModule,
        AirBookingResourceModule,
        AirOfferResourceModule,
        AirSilentBookingResourceModule,
        AirModule,
        AirQuoteResourceModule,
        AllSegmentDialogModule,
        ApiResourceModule,
        BestQuotesModule,
        BookingInformationModule,
        BookingModule,
        BookingRemarksModule,
        BookingTravellerAbstractModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
        ClipboardDirectiveModule,
        CommonModule,
        ConfirmDialogModule,
        DatePipeModule,
        DetailsDialogModule,
        FontAwesomeModule,
        FormsModule,
        GenericModule,
        GetTravellersModule,
        HostAliasPipeModule,
        IdentityInfoEditorModule,
        JourneyModule,
        LabelModule,
        ListModule,
        LoaderModule,
        LocationPipeModule,
        LocobookRoutingModule,
        LuggageModule,
        MatDialogModule,
        MatSelectModule,
        ModalModule,
        NotepadModule,
        NotificationModule,
        PermissionModule,
        PersonModule,
        PipesModule,
        PlainTextModule,
        PriceDifferenceModule,
        PricePipeModule,
        PricePipesModule,
        QuoteListModule,
        SamResourceModule,
        SearchAirTripModule,
        SearchFlightFormModule,
        SectorModule,
        SegmentModule,
        SegmentListModule,
        SentryModule,
        TravellerCardModule,
        TravellerFormModule,
        UIModule,
        PropalModule,
        BreadcrumbIqbaModule,
        TravellerModule,
        ActionQualityHelperModule,
        FareFamilyBenchmarkModule,
        ClickStopModule,
        LowCostCompanyModule,
        CacheQuotedAvailabilityModule,
        SSRModule,
        QuotedAvailabilityModule,
        EqualsModule,
        AncillaryServicesPageModule,
        AncillaryServicesSummaryModule,
        AncillaryServicesListModule,
        QuoteFilterModule,
        AncillaryServicesDomainModule,
        AirSearchModule
    ],
    declarations: [
        LocobookComponent,
        SearchComponent,
        PermissionDirective,
        SectorsComponent,
        PNRPriceTableComponent,
        AbstractCardComponent,
        AbstractItineraryCardComponent,
        SSRComponent,
        ItineraryChangeInformationComponent,
    ],
    bootstrap: [
        LocobookComponent,
    ],
    providers: [
        ExternalRedirectionService,
        AuthLocobookService,
        SegmentService,
        CarrierService,
        QuoteService,
        PriceService,
        DateService,
        PNRService,
        CustomFieldService,
        SearchFlightFormService,
        CreateBookingWarningMessageService,
        LanguageService,
        PricePipe,
        OfferService,
        SilentBookingService,
        AirBookingResourceService,
        ExternalApplicationService,
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: new AfiMatDialogDefaultOptions()},
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class LocobookModule { }
